import { createFileRoute, redirect } from '@tanstack/react-router'
import { stpBulkJobItem } from '@/lib/queries/stp-bulk-job-items'
import { stpBulkJob } from '@/lib/queries/stp-bulk-jobs'
import { StpBulkJobDetailPage } from '@/features/workspaces/stp/components/stp-bulk-job-detail-page'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId'
)({
  loader: async ({ context, params }) => {
    const [job] = await Promise.all([
      context.queryClient.query({
        ...stpBulkJob.findOne(params.jobId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...stpBulkJobItem.findManyByJob(params.jobId),
        staleTime: 'static',
      }),
    ])

    if (!job || job.workspace_id !== params.workspaceId) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/bulk-jobs',
        params: { orgId: params.orgId, workspaceId: params.workspaceId },
        replace: true,
      })
    }
  },
  component: StpBulkJobDetailPage,
})
